const signupProviders = {
  GOOGLE: 'google',
};

export default signupProviders;
